import { ThemeConfig } from "antd";

// Palette taken from https://www.takima.fr/
export const colors = {
  navy: "#10102b",
  "navy-2": "#1a1a2e",
  "navy-3": "#2b2854",
  pink: "#ff0066",
  "pink-hover": "#ff3399",
  "pink-light": "#fff0f6",
  background: "#f6f6fa",
  border: "#0000001a",
  white: "#ffffff",
  grey: "#f0f0f0",
  grey2: "#6b6b80",
  black: "#000000",
  "light-purple": "#f1e9fd",
  purple: "#632ca2",
  green: "#059669",
  red: "#d4183d",
  tagColor: "magenta",
};

export const fonts = {
  sans: 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  hand: '"Caveat", cursive',
};

export const theme: ThemeConfig = {
  token: {
    colorPrimary: colors.pink,
    colorLink: colors.pink,
    colorLinkHover: colors["pink-hover"],
    colorText: colors.navy,
    colorTextHeading: colors.navy,
    colorBgLayout: colors.background,
    colorBorderSecondary: colors.grey,
    colorError: colors.red,
    colorSuccess: colors.green,
    fontFamily: fonts.sans,
    fontSize: 15,
    borderRadius: 10,
    borderRadiusLG: 16,
  },
  components: {
    Layout: {
      siderBg: colors.navy,
      bodyBg: colors.background,
    },
    Menu: {
      darkItemBg: colors.navy,
      darkItemSelectedBg: colors.pink,
      darkItemSelectedColor: colors.white,
      darkItemColor: "rgba(255, 255, 255, 0.72)",
      darkItemHoverColor: colors.white,
      iconSize: 18,
      itemHeight: 44,
    },
    Card: {
      paddingLG: 20,
    },
    Table: {
      headerBg: colors.background,
      rowHoverBg: colors["pink-light"],
    },
    Button: {
      fontWeight: 600,
      primaryShadow: "none",
    },
  },
};
